<template>
  <div class="label-box">
    <div class="text" v-bind:style="textStyle">
      <span
        v-html="text"
        v-bind:class="{
          highlighted: highlighted,
          boxed: boxed
        }"
        v-bind:style="fontStyle"
      ></span>
    </div>
  </div>
</template>

<script>
import { STYLE_BASE_SIZE } from '@/constants/index'

export default {
  name: 'GSLabel',
  props: {
    text: { type: String, required: true },
    size: { type: Number },
    color: { type: String },
    opacity: { type: Number },
    align: { type: String },
    highlighted: { type: Boolean },
    boxed: { type: Boolean }
  },
  created: function () {
    this.fontStyle = {}
    this.textStyle = {}
    this.size && (this.fontStyle.fontSize = STYLE_BASE_SIZE * this.size + 'rem')
    this.color && (this.fontStyle.color = this.color)
    this.opacity && (this.fontStyle.opacity = this.opacity)
    this.align && (this.textStyle.textAlign = this.align)
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.label-box {
  padding: 0;

  .text {
    color: #E0C390;
    text-align: center;
    font-size: $font-size;
    letter-spacing: 0;
    line-height: $base-size * 56;

    .highlighted {
      color: #31BEFF;
    }

    .boxed {
      padding: $base-size * 25 $base-size * 55;
      background: #12232D;
      border-radius: $radius-size;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GSLabel.vue